import React from 'react';
import SearchableSelect from './SearchableSelect';

/**
 * CustomSelect - Now uses SearchableSelect with filter capability
 * Maintains backward compatibility with existing API
 */
const CustomSelect = ({
  name,
  value,
  onChange,
  options,
  required,
  placeholder = '',
  disabled = false,
  enableSmartSearch = false
}) => {
  // Convert onChange to work with SearchableSelect
  const handleChange = (event) => {
    // SearchableSelect already provides a synthetic event, just pass it through
    onChange(event);
  };

  return (
    <SearchableSelect
      name={name}
      value={value}
      onChange={handleChange}
      options={options}
      placeholder={placeholder}
      isRequired={required}
      isDisabled={disabled}
      enableSmartSearch={enableSmartSearch}
    />
  );
};

export default CustomSelect;